module.exports = __webpack_public_path__ + "static/media/Relative-Book-Web.cc71c6d0.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Relative-Book-Web.woff2
// module id = 741
// module chunks = 0